import { useEffect, useRef } from "react";
import { API_URI } from "@/apolloClient/utils";
export function useStatusSocket() {
    const socketRef = useRef(null);
    useEffect(() => {
        const socket = new WebSocket(`${API_URI}/api/v1/users/status`);
        socketRef.current = socket;
        socket.onopen = () => {
            const interval = setInterval(() => {
                if (socket.readyState === WebSocket.OPEN) {
                    socket.send("ping");
                }
            }, 5000);
            socket.onclose = () => {
                console.log("[Status WebSocket] connection closed");
                clearInterval(interval);
            };
            socket.onerror = (err) => {
                console.error("[Status WebSocket] Error", err);
                clearInterval(interval);
            };
        };
        return () => {
            socket.close();
        };
    }, []);
}
